import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";
import {
  FaFacebook,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaGooglePlay,
  FaApple,
  FaNewspaper,
  FaInfoCircle,
  FaMapMarkerAlt,
  FaShareAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import { useGetInfo } from "../../store/api/foooterApi";
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

function GenerelSettingList({ onEdit }) {
  const getInfo = useGetInfo();
  const {
    data: Data,
    isLoading: isLoading,
    error: error,
  } = useQuery({ queryKey: "footer-seeting", queryFn: getInfo });

  const data = Data?.data;

  function stripHtmlTags(html) {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "");
  }

  if (isLoading) {
    return <div className="my-5 text-center fw-bold">Loading...</div>;
  }

  // Handle error state
  if (error) {
    return (
      <div className="my-5 text-center fw-bold text-danger">
        Error: {error.message}
      </div>
    );
  }

  return (
    <div className="container my-5">
      <div className="d-flex justify-content-end mb-3">
        <button
          onClick={() => onEdit(data)}
          className="btn btn-warning text-white fs-4 mx-2"
          aria-label="Edit Document"
          type="button"
        >
          <MdEditDocument />
        </button>
      </div>

      <p className="bg-white rounded shadow p-3">
        <strong>Footer Text:</strong> {stripHtmlTags(data?.details)}
      </p>
    </div>
  );
}

export default GenerelSettingList;
